import { useState } from 'react';

/**
 * Wiederverwendbarer "Conversion-Bookmarklet holen"-Button. Generiert einen
 * draggable Link anhand eines Tracking-Codes — ist überall dort einsetzbar,
 * wo der Kontext (Kontakt + Projekt) bereits bekannt ist.
 */
export default function BookmarkletButton({
  trackingCode,
  contactLabel,
  variant = 'default',
}) {
  const [showHint, setShowHint] = useState(false);

  if (!trackingCode) return null;

  const origin = window.location.origin;
  const apiUrl = `${origin}/api/track/${trackingCode}`;
  const scriptUrl = `${origin}/ko-tracker.js`;

  // Derselbe Code wie in pages/Bookmarklet.jsx
  const bookmarkletUrl =
    'javascript:void(function(){' +
    `window.__KO_API='${apiUrl}';` +
    `window.__KO_CODE='${trackingCode}';` +
    'if(window.__KO_ACTIVE){window.__KO_CLEANUP();return;}' +
    `var s=document.createElement('script');s.src='${scriptUrl}?v='+Date.now();document.head.appendChild(s);` +
    '}())';

  const btnClass =
    variant === 'compact'
      ? 'inline-flex items-center gap-1.5 px-3 py-1.5 bg-amber-500 text-white rounded-lg text-[11.5px] font-semibold cursor-grab active:cursor-grabbing select-none hover:opacity-90'
      : 'inline-flex items-center gap-2 px-4 py-2 bg-amber-500 text-white rounded-lg text-[13px] font-semibold cursor-grab active:cursor-grabbing select-none hover:opacity-90 shadow-sm';

  return (
    <div className="inline-flex flex-col items-start gap-1.5">
      <a
        href={bookmarkletUrl}
        onClick={(e) => {
          e.preventDefault();
          setShowHint(true);
          setTimeout(() => setShowHint(false), 4000);
        }}
        draggable
        className={btnClass}
        title="In die Lesezeichen-Leiste ziehen"
      >
        🔖 Conversion-Bookmarklet
        {contactLabel && (
          <span className="text-white/80 font-normal">· {contactLabel}</span>
        )}
      </a>
      {showHint && (
        <div className="text-[10.5px] text-amber-700 bg-amber-50 border border-amber-200 rounded px-2 py-1 max-w-[320px]">
          Nicht klicken — in die <strong>Lesezeichen-Leiste ziehen</strong>. Dann auf der
          Kundenseite öffnen und Conversion-Element anklicken.
        </div>
      )}
    </div>
  );
}
